import { WidgetDefinition } from '../models/WidgetDefinition';

export const PivotTableWidgetDefinition: WidgetDefinition = {
    baseType: 'pivotTable',
    group: 'Charts',
    hasImage: true,
    highlights: ['Aggregated values of some identifiers based on the values of a selected identifier'],
    icon: 'fa-table',
    sortingOrder: 1250,
    title: 'Pivot table',
    type: 'pivotTable'
};